module.exports = __webpack_public_path__ + "img/eu-android.e5d7ac91.png";